<template>
  <div class="pa-5">
    <v-btn v-if="authenticated" color="primary" fab small @click="back" aria-label="Go back">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { manageAccessMixin } from '@/mixins/manageAccessMixin.js'

export default {
  name: 'BackButton',
  mixins: [manageAccessMixin],
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  methods: {
    back() {
      if (this.path) {
        this.$router.push(this.path)
      } else {
        this.$router.back()
      }
    }
  }
}
</script>
